class MRTestimonialsSlider {
  constructor(section) {
    this.section = section;
    this.viewport = section.querySelector('[data-mr-testimonials-viewport]');
    this.track = section.querySelector('[data-mr-testimonials-track]');
    this.cards = Array.from(section.querySelectorAll('[data-mr-testimonial-card]'));

    this.prevButton = section.querySelector('[data-mr-testimonials-prev]');
    this.nextButton = section.querySelector('[data-mr-testimonials-next]');
    this.dotsContainer = section.querySelector('[data-mr-testimonials-dots]');

    this.currentIndex = 0;
    this.dots = [];

    if (!this.viewport || !this.track || this.cards.length === 0) {
      return;
    }

    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  init() {
    this.createDots();
    this.bindEvents();
    this.update();
  }

  getVisibleCards() {
    const viewportWidth = window.innerWidth;

    if (viewportWidth <= 749) {
      return 1;
    }

    if (viewportWidth <= 989) {
      return 2;
    }

    return 3;
  }

  getMaxIndex() {
    return Math.max(0, this.cards.length - this.getVisibleCards());
  }

  getCardStep() {
    if (this.cards.length === 0) {
      return 0;
    }

    const firstCard = this.cards[0];
    const trackStyles = window.getComputedStyle(this.track);
    const gap = parseFloat(trackStyles.gap) || 0;

    return firstCard.getBoundingClientRect().width + gap;
  }

  createDots() {
    if (!this.dotsContainer) {
      return;
    }

    this.dotsContainer.innerHTML = '';

    const totalPages = this.getMaxIndex() + 1;

    for (let index = 0; index < totalPages; index += 1) {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'mr-testimonials-slider__dot';
      button.setAttribute('aria-label', `Ir al testimonio ${index + 1}`);

      button.addEventListener('click', () => {
        this.currentIndex = index;
        this.update();
      });

      this.dotsContainer.appendChild(button);
    }

    this.dots = Array.from(this.dotsContainer.children);
  }

  bindEvents() {
    this.prevButton?.addEventListener('click', () => {
      this.currentIndex = Math.max(0, this.currentIndex - 1);
      this.update();
    });

    this.nextButton?.addEventListener('click', () => {
      this.currentIndex = Math.min(
        this.getMaxIndex(),
        this.currentIndex + 1
      );

      this.update();
    });

    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    const maxIndex = this.getMaxIndex();

    if (this.currentIndex > maxIndex) {
      this.currentIndex = maxIndex;
    }

    this.createDots();
    this.update();
  }

  update() {
    const step = this.getCardStep();
    const offset = this.currentIndex * step;

    this.track.style.transform = `translateX(-${offset}px)`;

    if (this.prevButton) {
      this.prevButton.disabled = this.currentIndex === 0;
    }

    if (this.nextButton) {
      this.nextButton.disabled = this.currentIndex >= this.getMaxIndex();
    }

    this.dots.forEach((dot, index) => {
      const isActive = index === this.currentIndex;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

function initMRTestimonials(root = document) {
  root
    .querySelectorAll('[data-mr-testimonials]')
    .forEach((section) => {
      if (section.dataset.mrTestimonialsInitialized === 'true') {
        return;
      }

      section.dataset.mrTestimonialsInitialized = 'true';

      new MRTestimonialsSlider(section);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initMRTestimonials();
});

/*
 * Shopify vuelve a renderizar secciones dinámicamente
 * dentro del editor visual.
 */
document.addEventListener('shopify:section:load', (event) => {
  initMRTestimonials(event.target);
});
